import { List, ListItem, ListItemIcon, ListItemText, Popover } from "@mui/material";
import { cloneElement, useState } from "react";
import Icons from "../../assets/js/Icons";
import moment from "moment";

const DAYS_ORDER = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

function Availability({ availability, trigger }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const scheduleKeys = Object.keys(availability?.schedule || {}).sort((a, b) => {
    const indexA = DAYS_ORDER.indexOf(a.toLowerCase());
    const indexB = DAYS_ORDER.indexOf(b.toLowerCase());
    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    return 0;
  });

  return (
    <>
      {cloneElement(trigger, {
        onClick: handleClick,
        "aria-describedby": id,
      })}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        disableScrollLock={false}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        slotProps={{
          paper: { sx: { border: "2px solid", borderColor: "primary.light", mt: 1 } }
        }}
      >
        <List>
          {(!availability?.schedule || scheduleKeys.length === 0) ?
            <ListItem>
              <ListItemIcon sx={{ fontSize: 18, minWidth: "auto", mr: 0.8 }}>
                <Icons.CalendarSolid />
              </ListItemIcon>
              <ListItemText
                primary="Chat availability not scheduled"
                slotProps={{
                  root: { sx: { m: 0 } },
                  // secondary: { sx: { fontSize: 14, lineHeight: "1" } },
                  primary: { sx: { textTransform: "capitalize", fontSize: 15, lineHeight: "1.2" } },
                }}
              />
            </ListItem> :
            scheduleKeys.map((day, i) => (
              <ListItem key={i}>
                <ListItemIcon sx={{ fontSize: 18, minWidth: "auto", mr: 0.8 }}>
                  <Icons.CalendarSolid />
                </ListItemIcon>
                <ListItemText
                  primary={day}
                  slotProps={{
                    root: { sx: { m: 0 } },
                    secondary: { sx: { fontSize: 14, lineHeight: "1" } },
                    primary: { sx: { textTransform: "capitalize", fontSize: 15, lineHeight: "1.2" } },
                  }}
                  secondary={`
                    ${moment
                      .tz(
                        availability?.schedule?.[day]?.startTime,
                        "HH:mm",
                        availability?.timeZone
                      )
                      .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                      .format("hh:mm A")}
                                            to 
                                            ${moment
                      .tz(
                        availability?.schedule?.[day]?.endTime,
                        "HH:mm",
                        availability?.timeZone
                      )
                      .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                      .format("hh:mm A")}
                  `}
                />
              </ListItem>
            ))
          }
        </List>
      </Popover>

      {/* <List>
      {(!availability?.schedule || Object.keys(availability?.schedule)?.length === 0) ?
        <ListItem>
          <ListItemIcon sx={{ fontSize: 18, minWidth: "auto", mr: 0.8 }}>
            <Icons.CalendarSolid />
          </ListItemIcon>
          <ListItemText
            primary="Chat availability not scheduled"
            slotProps={{
              root: { sx: { m: 0 } },
              // secondary: { sx: { fontSize: 14, lineHeight: "1" } },
              primary: { sx: { textTransform: "capitalize", fontSize: 15, lineHeight: "1.2" } },
            }}
          />
        </ListItem> :
        Object?.keys(availability?.schedule)?.map((day, i) => (
          <ListItem key={i}>
            <ListItemIcon sx={{ fontSize: 18, minWidth: "auto", mr: 0.8 }}>
              <Icons.CalendarSolid />
            </ListItemIcon>
            <ListItemText
              primary={day}
              slotProps={{
                root: { sx: { m: 0 } },
                secondary: { sx: { fontSize: 14, lineHeight: "1" } },
                primary: { sx: { textTransform: "capitalize", fontSize: 15, lineHeight: "1.2" } },
              }}
              secondary={
                `
                                            ${moment
                  .tz(
                    availability?.schedule?.[day]?.startTime,
                    "HH:mm",
                    availability?.timeZone
                  )
                  .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                  .format("hh:mm A")}
                                            to 
                                            ${moment
                  .tz(
                    availability?.schedule?.[day]?.endTime,
                    "HH:mm",
                    availability?.timeZone
                  )
                  .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                  .format("hh:mm A")}
                                            `}
            />
          </ListItem>
        ))
      }
    </List> */}
    </>
  )
}

export default Availability